//export const API_BASE_URL = "http://localhost:5001/api";
export const API_BASE_URL = "https://api.yogarefer.com/api";

export const HAND = [
  {
    key: "H-1",
    title: "Namaskar",
    // img: hand1,
    sanskrit: "Namaskar",
    english:
      "Prayer - Vanakam is a tradition in Tamil culture. It has many meanings such as worship, prayer, affection, admiration, greeting, welcoming, thanking, etc.",
    example: "Padmasana Namaskar",
  },
  {
    key: "H-2",
    title: "Viparita Namaskar",
    // img: hand2,
    sanskrit: "Viparita Namaskar",
    english:
      "Reverse Prayer - Bowing backwards with both hands joined is called Viparita Namaskar.",
    example: "Viparita Namaskar Padmasana",
  },
  {
    key: "H-3",
    title: "Urdhva Hasta",
    // img: hand3,
    sanskrit: "Urdhva Hasta",
    english:
      "Upward Hands - The act of raising both hands is called Urdhva Hasta.",
    example: "Urdhva Hasta Padmasana",
  },
  {
    key: "H-4",
    title: "Baddha Hasta",
    // img: hand4,
    sanskrit: "Baddha Hasta",
    english:
      "Bound Hands - The act of joining two hands together is called Baddha Hasta.",
    example: "Baddha Hasta Padmasana",
  },
  {
    key: "H-5",
    title: "Urdhva Baddha Hasta",
    // img: hand5,
    sanskrit: "Urdhva Baddha Hasta",
    english:
      "Raised Bound Hands - Raising both hands together is called Urdhva Baddha Hasta.",
    example: "Urdhva Baddha Hasta Padmasana",
  },
  {
    key: "H-6",
    title: "Hasta Garudasana",
    // img: hand6,
    sanskrit: "Hasta Garudasana",
    english:
      "Eagle Pose on Hands - Hasta Garuda is an asana where the hands are folded like an eagle.",
    example: "Hasta Garudasana in Padmasana",
  },
  {
    key: "H-7",
    title: "Hasta Gomukhasana",
    // img: hand7,
    sanskrit: "Hasta Gomukhasana",
    english:
      "Cow Face Pose on Hands - The asana where the hands are folded behind the back and made into a cow's face is called Hasta Gomukha.",
    example: "Hasta Gomukhasana in Padmasana",
  },
  {
    key: "H-8",
    title: "Manibandha",
    // img: hand8,
    sanskrit: "Manibandha",
    english:
      "Wrist Stretch - The asana performed by turning and further bending the wrist is called Manibandha.",
    example: "Uttana Manibandha Utkatasana",
  },
  {
    key: "H-9",
    title: "Eka Hasta",
    // img: hand9,
    sanskrit: "Eka Hasta",
    english: "One Hand - An asana performed using only one hand.",
    example: "Eka Hasta Utthita Chaturanga Dandasana",
  },
  {
    key: "H-10",
    title: "Prasarita Hasta",
    // img: hand1,
    sanskrit: "Prasarita Hasta",
    english:
      "Spreading Hands - Prasarita Hasta is the posture done with the arms spread out.",
    example: "Prasarita Hasta Chaturanga Dandasana",
  },
  {
    key: "H-11",
    title: "Cross Hand",
    // img: hand11,
    sanskrit: "Hasta Kulpa Setu Bandha Sarvangasana",
    english: "Crossed Arms - An asana performed using crossed arms.",
    example: "Hasta Kulpa Setu Bandha Sarvangasana",
  },
  {
    key: "H-12",
    title: "Parivritta Namaskar",
    // img: hand12,
    sanskrit: "Parivritta Namaskar",
    english:
      "Revolved Prayer - The act of turning the body and bowing is called Parivritta Namaskar.",
    example: "Parivritta Namaskar in Padmasana",
  },
  {
    key: "H-13",
    title: "Parivritta Baddha Hasta",
    // img: hand13,
    sanskrit: "Parivritta Baddha Hasta",
    english:
      "Revolved Bound Hands - Turning the body with the hands together is Parivritta Baddha Hasta.",
    example: "Parivritta Baddha Hasta Utkatasana",
  },
];

export const LEG = [
  {
    key: "L-1",
    title: "Pada Gomukha",
    // img: leg1,
    sanskrit: "Pada Gomukhasana",
    english:
      "Cow face pose on leg - The asana that makes the legs look like the face of a cow is called Pada Gomuka.",
    example: "Pada Gomukhasana",
  },
  {
    key: "L-2",
    title: "Pada Garuda",
    // img: leg2,
    sanskrit: "Pada Garudasana",
    english:
      "Eagle pose on leg - The asana in which the legs are crossed and made like an eagle is called Pada Garuda.",
    example: "Pada Garudasana",
  },
  {
    key: "L-3",
    title: "Prapada",
    // img: leg3,
    sanskrit: "Prapada",
    english:
      "Tip Toe Pose - The asana performed while standing on tiptoe is called Prapada.",
    example: "Janu Shirsha Prapada Utkatasana",
  },
  {
    key: "L-4",
    title: "Parshva Pada",
    // img: leg4,
    sanskrit: "Parshva Pada",
    english:
      "Leg to the Side - The asana done with one leg extended to the side is called Parshva Pada.",
    example: "Parshva Pada Shirsha Bitilasana",
  },
  {
    key: "L-5",
    title: "Pada Akunchanasana",
    // img: leg5,
    sanskrit: "Pada Akunchanasana",
    english:
      "Leg Contraction Knee Bend - The asana in which the leg is shortened is called Pada Akunchanasana.",
    example: "Pada Akunchanasana in Salamba Sarvangasana",
  },
  {
    key: "L-6",
    title: "Prasarita Pada",
    // img: leg6,
    sanskrit: "Prasarita Pada",
    english:
      "Spread your legs - The asana done with the legs spread is called Prasarita Pada.",
    example: "Prasarita Pada Purvottanasana",
  },
  {
    key: "L-7",
    title: "Eka Pada",
    // img: leg7,
    sanskrit: "Eka Pada",
    english:
      "One leg - The asana performed using only one leg is called Eka Pada.",
    example: "Eka Pada Halasana",
  },
  {
    key: "L-8",
    title: "Vishama Pada",
    // img: leg8,
    sanskrit: "Vishama Pada",
    english:
      "Uneven Leg - The asana performed with the feet in an uneven position is called Vishama Pada.",
    example: "Parshva Vishama Pada Malasana",
  },
  {
    key: "L-9",
    title: "Kulpa",
    // img: leg9,
    sanskrit: "Kulpa",
    english:
      "Ankle - Kulpa is the asana done with the ankles i.e. the upper part of the toes on the floor.",
    example: "Kulpa Utkatasana",
  },
  {
    key: "L-10",
    title: "Book Stand",
    // img: leg10,
    sanskrit: "Grantadara",
    english: "Cross Leg - A posture performed with the legs crossed.",
    example: "Chikkyasana or Book Stand Pose",
  },
];

export const OTHER = [
  {
    key: "O-1",
    title: "Ardha",
    // img: other1,
    sanskrit: "Ardha",
    english: "Half - Doing only half of an asana.",
    example: "Ardha Padmasana or half lotus pose",
  },
  {
    key: "O-2",
    title: "Adho Mukha",
    // img: other2,
    sanskrit: "Adho Mukha",
    english: "Downward facing - The asana with the face facing down.",
    example: "Adho Mukha Shvanasana",
  },
  {
    key: "O-3",
    title: "Urdhva Mukha",
    // img: other3,
    sanskrit: "Urdhva Mukha",
    english: "Upward facing - The asana with the face facing upward.",
    example: "Urdhva Mukha Padmasana",
  },
  {
    key: "O-4",
    title: "Parshva",
    // img: other4,
    sanskrit: "Parshva",
    english:
      "Side bend - Bending the body sideways from left to right is lateral asana.",
    example: "Parshva Padmasana",
  },
  {
    key: "O-5",
    title: "Parivritta",
    // img: other5,
    sanskrit: "Parivritta",
    english: "Revolved - A posture that twists the body left and right.",
    example: "Parivritta Padmasana",
  },
  {
    key: "O-6",
    title: "Back bend",
    // img: other6,
    sanskrit: "Prushtham vakrata",
    english: "Back bend - It is a posture that bends the body backwards.",
    example: "Padmasana",
  },
  {
    key: "O-7",
    title: "Forward Bend",
    // img: other7,
    sanskrit: "Agre vakrata",
    english: "Forward bend - It is a posture that bends the body forward.",
    example: "Padmasana",
  },
];

export const animatedMenuStyles = `
  .yoga-menu {
    background: transparent !important;
    border: none !important;
  }

  .yoga-menu .ant-menu-item {
    font-size: 15px;
    letter-spacing: 0.08em;
    margin: 8px 6px;
    background: white !important;
    border: 2px solid black;
    height: 42px;
    line-height: 42px;
    position: relative;
    overflow: hidden;
  font-family: "Manrope", sans-serif;
  }

  /* ❌ REMOVE AntD default hover + active background */
  .yoga-menu .ant-menu-item:hover,
  .yoga-menu .ant-menu-item:active,
  .yoga-menu .ant-menu-item:focus-visible {
    background: white !important;
  }

  /* ❌ REMOVE AntD hover overlay */
  .yoga-menu .ant-menu-item::after {
    display: none !important;
  }

  /* ✅ TEXT DEFAULT (asana name) */
  .yoga-menu .ant-menu-title-content {
    color: black !important;
    position: relative;
    z-index: 2;
    transition: color 0.3s ease;
  }

  /* ✅ TEXT HOVER → WHITE */
  .yoga-menu .ant-menu-item:hover .ant-menu-title-content {
    color: white !important;
  }

  /* Icon default */
  .yoga-menu .ant-menu-item-icon {
    color: black !important;
    z-index: 2;
    transition: color 0.3s ease;
  }

  /* Icon hover → white */
  .yoga-menu .ant-menu-item:hover .ant-menu-item-icon {
    color: white !important;
  }

  /* 🎯 Animation layer */
  .yoga-menu .ant-menu-item::before {
    content: "";
    position: absolute;
    width: 28px;
    height: 100%;
    background: black;
    border-radius: 50%;
    top: 0;
    left: -14px;
    transition: transform 0.5s ease-out;
    z-index: 1;
  }

  .yoga-menu .ant-menu-item:hover::before {
    transform: scale(12);
  }

  /* Selected item */
  .yoga-menu .ant-menu-item-selected {
    background: white !important;
  }
`;
